module.exports = __webpack_public_path__ + "img/gif3D.3555d939.gif";